.SubProductCell {
  display: grid;
  grid: auto / 1fr max-content;
  align-items: center;
  gap: var(--space-lg);

  &:has([data-slot="count"]) {
    gap: var(--space-sm);
  }

  & > div {
    display: flex;
    gap: var(--space-xs);
    align-items: center;
  }
}

.TotalCount {
  min-width: fit-content;
}

.EmptySubProducts {
  display: flex;
  width: 100%;
  justify-content: center;
}

.SelectionCount {
  position: relative;
  width: 25px;
  aspect-ratio: 1;
  border: 1px solid var(--secondary);
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: var(--secondary);
  font-size: 0.875rem;
  transition:
    background-color 200ms,
    color 200ms;

  &:hover {
    background-color: var(--secondary);
    color: var(--white);
  }
}

.TooltipContent {
  width: fit-content;
  max-width: calc(var(--column-width) - 34px);
  border-color: var(--secondary);
  background-color: var(--white);
  text-align: left;

  h4 {
    font-size: 0.9375rem;
    font-weight: 500;
    color: var(--secondary);
  }

  ol {
    li {
      font-size: 0.9375rem;
      margin-top: var(--space-sm);
      color: var(--black);
    }
  }
}
